export const SET_TWP_BENEFITS_MODAL_SHOWN =
	'command.twp-benefits-modal.SET_TWP_BENEFITS_MODAL_SHOWN' as const;

export type SetTwpBenefitsModalShownAction = {
	type: typeof SET_TWP_BENEFITS_MODAL_SHOWN;
	payload: boolean;
};
